__turbopack_context__.v({
  "accordionSlideOverwrite": "textField-module-scss-module__02ixBa__accordionSlideOverwrite",
  "container": "textField-module-scss-module__02ixBa__container",
  "fadeIn": "textField-module-scss-module__02ixBa__fadeIn",
  "fadeOut": "textField-module-scss-module__02ixBa__fadeOut",
  "label": "textField-module-scss-module__02ixBa__label",
  "scaleIn": "textField-module-scss-module__02ixBa__scaleIn",
  "scaleOut": "textField-module-scss-module__02ixBa__scaleOut",
  "textField": "textField-module-scss-module__02ixBa__textField",
  "zoomIn": "textField-module-scss-module__02ixBa__zoomIn",
  "zoomOut": "textField-module-scss-module__02ixBa__zoomOut",
});
